import "./App.css";
import * as React from "react";
import { useDispatch } from "react-redux";
import { Routes, Route } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import ResetPassword from "./Login/ResetPassword";
import ResetMyPassword from "./user page/ResetPassword";
import { getAllUsers } from "./actions/user";
import Login from "./Login/login";
import { getHeadOfficeAdviceFromBranches } from "./actions/advice";
import { getAllBranchAdvice } from "./actions/branchAdvice";
import { getAllLocation } from "./actions/location";
import InternetConnectionMonitor from "./Internet Connection/InternetConnection";
import { getAllAdviceData } from "./actions/allAdviceData";
import { getAllSpecificBranchAdvice } from "./actions/specificBranchAdvice";
import { receivingBranchData } from "./actions/recevingBranch";
import { unapprovedAdvices } from "./actions/unapprovedAdvice";
import { updateUser } from "./actions/user";
import AdviceHome from "./Advice Home/Advice";
import Location from "./Location/Location";
import PrepareAdvice from "./Prepare Advice/PrepareAdvice";
import Report from "./Report/Report";
import UserAccountPage from "./user page/UserAccountPage";
import Approval from "./Approvals/Approvals";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import AppLayout from "./ui/AppLayout";
import ProtectedRoute from "./ui/ProtectedRoute";
function App() {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (user) {
      dispatch(getAllUsers());
      dispatch(getHeadOfficeAdviceFromBranches());
      dispatch(getAllBranchAdvice());
      dispatch(getAllLocation());
      dispatch(getAllSpecificBranchAdvice());
      dispatch(getAllAdviceData());
      dispatch(receivingBranchData());
      dispatch(unapprovedAdvices());
    }
  }, [dispatch, user]);

  React.useEffect(() => {
    if (user) {
      dispatch(
        updateUser(user?.results._id, {
          login: "yes",
          system: "advice",
        })
      );
    }
  }, [dispatch, user]);
  return (
    <HelmetProvider>
      <InternetConnectionMonitor />
      <Routes>
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }>
          <Route path='/advice' element={<AdviceHome />} />
          <Route index element={<AdviceHome />} />
          <Route path='/advice/locations' element={<Location />} />
          <Route
            path='/advice/prepare-new-advice'
            element={<PrepareAdvice />}
          />
          <Route path='/advice/report' element={<Report />} />
          <Route path='/advice/user-page' element={<UserAccountPage />} />

          <Route path='/advice/approval' element={<Approval />} />
        </Route>

        <Route path='/advice/forgotPassword' element={<ResetPassword />} />
        <Route
          path='/advice/resetMyPassword/:token'
          element={<ResetMyPassword />}
        />
        <Route path='/advice/login' element={<Login />} />
      </Routes>
      <Toaster
        position='top-center'
        gutter={12}
        containerStyle={{ margin: "8px" }}
        toastOptions={{
          success: {
            duration: 3000,
          },
          error: {
            duration: 6000,
          },
          style: {
            fontSize: "14px",
            maxWidth: "500px",
            padding: "10px 20px",
            backgroundColor: "#ffffff",
            color: "#6b7280",
          },
        }}
      />
    </HelmetProvider>
  );
}
export default App;
